import L from 'leaflet'; // L 객체를 임포트합니다.

export const RESTAURANT    = 0;
export const SUPERMARKET   = 1;
export const HOTEL         = 2;
export const TAEKWONDO     = 3;
export const KOREAN_SCHOOL = 4;
export const RELIGION      = 5;
export const ALL           = 100;

export const optionsFilterType = [
  { value: 0, label: '한식당' },
  { value: 1, label: '한인마트' },
  { value: 2, label: '한인민박' },
  { value: 3, label: '태권도' },
  { value: 4, label: '한글학교' }
]

export const greenMarker = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    shadowSize: [41, 41],
    className: 'custom-green-marker' // 이 마커에만 적용될 CSS 클래스
});